/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'cvlib';
import { emailRegex } from '../../utils';

const EmailForm = props => {
  const {
    email_tooltip_valid_label_validation,
    registerMail_tooltip_error_label,
    sso_inicia_sesion_text,
    registro_mail,
    register_access_option_button_next,
    login_access_placeHolder_textfield,
    password_tooltip_completeField_label_validation,
  } = props.translations;
  const { landing_espn_logo_claro_tv_ic } = props.assets;
  const [emptyEmail, setEmptyEmail] = useState(true);
  const { onNextClicked, emailValid } = props;
  const elements = [
    {
      element: 'logo',
      content: landing_espn_logo_claro_tv_ic,
      position: 'center',
      expand: 0.01,
    },
    {
      element: 'title',
      content: sso_inicia_sesion_text,
      expand: 0.01,
    },
    {
      element: 'group',
      direction: 'vertical',
      expand: 0.5,
      children: [
        {
          element: 'subtitle',
          content: registro_mail,
          expand: 0.3,
        },
        {
          element: 'item',
          type: 'email',
          expand: 0.3,
          placeholder: login_access_placeHolder_textfield,
          message: email_tooltip_valid_label_validation,
          error: !emailValid && registerMail_tooltip_error_label,
          name: 'emailRegister',
          id: 'emailRegister',
          autoFocus: true,
          registerOptions: {
            required: password_tooltip_completeField_label_validation,
            pattern: {
              value: emailRegex,
              message: email_tooltip_valid_label_validation,
            },
          },
          onChange: ({ target }) => setEmptyEmail(target.value.length <= 0),
        },
      ],
    },
    {
      element: 'button',
      type: 'red',
      content: register_access_option_button_next,
      expand: 0.2,
      submit: onNextClicked,
      dimmed: emptyEmail,
    },
  ];

  return <Form elements={elements} />;
};

EmailForm.propTypes = {
  onNextClicked: PropTypes.func.isRequired,
  emailValid: PropTypes.bool,
  assets: PropTypes.shape({
    landing_espn_logo_claro_tv_ic: PropTypes.string,
  }),
  translations: PropTypes.shape({
    registerMail_tooltip_error_label: PropTypes.string,
    email_tooltip_valid_label_validation: PropTypes.string,
    sso_inicia_sesion_text: PropTypes.string,
    registro_mail: PropTypes.string,
    register_access_option_button_next: PropTypes.string,
    login_access_placeHolder_textfield: PropTypes.string,
  }),
};

EmailForm.defaultProps = {
  emailValid: true,
};

export default EmailForm;
